import { IconButton, ListItem, ListItemText, Stack, TableCell, TableRow } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import DeleteIcon from '@mui/icons-material/Delete';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SelectField from '../../selectField';

type Props = {
  entity: any;
  sourceEntity?: any;
  sourceEntities: any[];
  errror?: string;
  onAdd: (sourceEntity: any) => void;
  onDelete: (sourceEntity: any) => void;
  onCancelAdd: () => void;
};

const SourceEntity = ({ entity, sourceEntity, sourceEntities = [], errror, onAdd, onDelete, onCancelAdd }: Props) => {
  const { t } = useTranslation();

  const [sourceEntityId, setSourceEntityId] = useState<any>(sourceEntity?.sourceEntityId);
  const [sourceEntityName, setSourceEntityName] = useState<string>('');

  const [editMode, setEditMode] = useState(false);
  const [errors, setErrors] = useState<any>({});

  useEffect(() => {
    const es = sourceEntities.find((es) => es.entityId === sourceEntityId);
    setSourceEntityName(`${es?.entityName} (${t(`common.entityType.${es?.entityType}`)})`);
  }, [sourceEntities, sourceEntityId]);

  const handleSourceEntityChange = (sourceEntityId: string) => {
    setSourceEntityId(sourceEntityId);
  };

  const cancelAdd = () => {
    onCancelAdd();
  };

  const addEntitySource = () => {
    let hasError = false;
    const errors: any = {};
    if (!sourceEntityId) {
      errors.sourceEntityId = t('common.errors.requiredField');
      hasError = true;
    }

    setErrors(errors);
    if (!hasError) {
      const es = sourceEntities.find((es) => es.entityId === sourceEntityId);
      onAdd({
        sourceEntityId: sourceEntityId,
        sourceEntityType: es.entityType,
        sourceEntityDefId: es.entityDefId,
        targetEntityId: entity.id || entity.nodeId,
        targetEntityType: entity.entityType,
        targetEntityDefId: entity.entityDefId,
      });
    }
  };

  const deleteEntitySource = () => {
    const es = sourceEntities.find((es) => es.entityId === sourceEntityId);
    onDelete({
      sourceEntityId: sourceEntityId,
      sourceEntityType: es.entityType,
      sourceEntityDefId: es.entityDefId,
      targetEntityId: entity.id || entity.nodeId,
      targetEntityType: entity.entityType,
      targetEntityDefId: entity.entityDefId,
    });
  };

  return sourceEntity ? (
    <ListItem
      secondaryAction={
        <IconButton size="small" onClick={() => deleteEntitySource()} color="error">
          <DeleteIcon fontSize="small" />
        </IconButton>
      }
    >
      <ListItemText primary={sourceEntityName} />
    </ListItem>
  ) : (
    <Stack justifyContent={'flex-start'} direction={'row'}>
      <SelectField
        required
        options={sourceEntities.map((es) => {
          return {
            value: es.entityId,
            label: es.entityName || `${t(`common.entityType.${es.entityType}`)}`,
          };
        })}
        value={sourceEntityId}
        autoFocus
        onChange={handleSourceEntityChange}
        error={errors.sourceEntityId}
        disabled={!(!sourceEntity || editMode)}
      />
      <IconButton size="small" onClick={addEntitySource} color="primary">
        <CheckIcon fontSize="small" />
      </IconButton>
      <IconButton size="small" onClick={() => cancelAdd()}>
        <ClearIcon fontSize="small" />
      </IconButton>
    </Stack>
  );
};

export default SourceEntity;
